import React from 'react';
import ReverbChannel from "@/lib/socket/ReverbChannel";

function Sockets() {
    return (
        <>
            <ReverbChannel publicChannel={'test'}
                           event={'test'}
                           action={(a) => {
                               console.log(a);
                               console.log('connected to socket');
                           }} />
        </>
    );
}

export default Sockets;